import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context('./langs', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const translationData = {messages: {}, numberFormats: {}, dateTimeFormats: {}};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            translationData.messages[locale] = locales(key).messages;
            translationData.numberFormats[locale] = locales(key).numberFormats;
            translationData.dateTimeFormats[locale] = locales(key).dateTimeFormats;
        }
    });
    return translationData;
}

const i18n = new VueI18n({
    locale: localStorage.getItem('language') || 'it',
    fallbackLocale: 'it',
    ...loadLocaleMessages()
});

//Fallback in case of unrecognized browser language
if (!i18n.availableLocales.includes(i18n.locale)) {
    i18n.locale = 'it';
}

export default i18n;